/**
 * 운영 배포 직후(또는 CDN/브라우저 캐시로) main 번들은 구버전인데
 * chunk 파일은 신규 이미지에 맞게 바뀌어 옛 hash 청크가 404 → ChunkLoadError.
 * 한 번 hard reload에 가까운 전체 새로고침으로 index.html·main을 다시 맞춤.
 * 같은 탭에서 자동 재시도는 1회만(무한 새로고침 방지).
 */
const RELOAD_KEY = 'gopai_chunk_reload_once_v1';

function isChunkLoadFailure(reason) {
  if (reason == null) return false;
  if (reason.name === 'ChunkLoadError') return true;
  const m = String(reason?.message != null ? reason.message : reason);
  return m.includes('Loading chunk') && m.includes('failed');
}

export function registerChunkLoadRecovery() {
  if (typeof window === 'undefined') {
    return;
  }

  // 정상 로드 후 플래그 초기화 — 서버 재기동 직후 1회 자동 복구가 막히지 않도록
  window.addEventListener('load', () => {
    sessionStorage.removeItem(RELOAD_KEY);
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadFailure(event.reason)) return;
    if (sessionStorage.getItem(RELOAD_KEY) === '1') {
      return;
    }
    event.preventDefault();
    sessionStorage.setItem(RELOAD_KEY, '1');
    window.location.reload();
  });

  window.addEventListener(
    'error',
    (event) => {
      // unhandledrejection과 동일 기준: ChunkLoadError 또는 "Loading chunk" + "failed"
      const reason =
        event.error != null ? event.error : event?.message != null ? { message: event.message } : null;
      if (!isChunkLoadFailure(reason)) {
        return;
      }
      if (sessionStorage.getItem(RELOAD_KEY) === '1') {
        return;
      }
      sessionStorage.setItem(RELOAD_KEY, '1');
      window.location.reload();
    },
    true
  );
}
